import { getAirports } from '../../shared/data-services/airport-service';
import { getShiftHistoryChange } from '../../shared/data-services/shift-service';
import { getAllZonesByEmployee } from '../../shared/data-services/management-zone-service';
import { getUser } from '../../shared/auth-service';
import dayjs from "dayjs";

export async function getAllAirports() {
    return await getAirports();
};

export async function getMonthsView(strfechaInicio, strfechaFin) {
    const fechaInicio = new Date(strfechaInicio);
    const fechaFin = new Date(strfechaFin);
    const data = [];

    while (fechaFin >= fechaInicio) {
        const Month = new Intl.DateTimeFormat('es-CO', { month: "long" }).format(new Date(fechaInicio.getFullYear(), fechaInicio.getMonth(), 1));
        data.push({
            Year: fechaInicio.getFullYear(),
            Month: Month.charAt(0).toUpperCase() + Month.slice(1)
        });
        fechaInicio.setMonth(fechaInicio.getMonth() + 1);
    }
    return data;
};

export async function getZones() {
    try {
        const user = getUser(); // Asegúrate de que este devuelve el objeto con employeeId
        const employeeId = user.employeeId;

        const data = await getAllZonesByEmployee(employeeId);
        return data || [];
    } catch (error) {
        console.error('Error al obtener las zonas:', error);
        return [];
    }
}

export async function getData(params) {
    //console.log(params);
    const data = await getShiftHistoryChange(params);
    //console.log(data);
    return data.map((element, index) => ({
        "id": element.id || index, // Ensure a unique row ID for MUI DataGrid
        "employeeId": element.employeeId,
        "dateFull": element.date ? new Date(element.date).toISOString().split('T')[0] : "",
        "dateDay": element.date ? new Date(element.date).getDate() : "",
        "name": element.nombreCompleto,
        "area": element.area,
        "zoneDescription": element.zoneDescription,
        "airport": element.airportCode,
        "shiftCode": element.shiftCode,
        "shiftDescription": element.descriptionShift,
        "abbreviation": element.abbreviation || "",
        "changeType": element.changeType === "1" ? "TRACKING" : element.changeType === "2" ? "COLABORADOR" : element.changeType,
        "state": element.state === "1" ? "ASIGNADO" : element.state === "2" ? "REEMPLAZADO" : element.state === "3" ? "CAMBIO CU" : element.state,
        "creationUser": element.creationUser,
        "creationDate": element.creationDate ? dayjs(element.creationDate).format('YYYY-MM-DD HH:mm') : "",
        "updateUser": element.updateUser,
        "updated": element.updated ? dayjs(element.updated).format('YYYY-MM-DD HH:mm') : "",
    }));
};

export async function getDataExport(params) {
    const data = await getData(params);
    const dataReal = [];

    data.forEach(element => {
        const itemReal = [
            { v: element.employeeId, t: "s" },
            { v: element.name, t: "s" },
            { v: element.airport, t: "s" },
            { v: element.area, t: "s" },
            { v: element.zoneDescription, t: "s" },           
            { v: element.dateFull, t: "s" },
            { v: element.shiftCode, t: "s" },
            { v: element.shiftDescription, t: "s" },
            { v: element.abbreviation, t: "s" },
            { v: element.changeType, t: "s" },
            { v: element.state, t: "s" },
            { v: element.creationUser, t: "s" },
            { v: element.creationDate, t: "s" },
            { v: element.updateUser, t: "s" },
            { v: element.updated, t: "s" }
        ];

        dataReal.push(itemReal);
    });

    return dataReal;
};

export async function getColumns(dataShift) {
    return [
        { field: 'id', headerName: 'ID', width: 60, hide: true },
        { field: 'employeeId', headerName: 'Identificación', width: 150 },
        { field: 'name', headerName: 'Nombre completo', width: 350 },
        { field: 'airport', headerName: 'Base', width: 70 },
        { field: 'area', headerName: 'Área', width: 100 },
        { field: 'zoneDescription', headerName: 'Zona', width: 150 },      
        { field: 'dateFull', headerName: 'Fecha', width: 120 },
        { field: 'shiftCode', headerName: 'Turno', width: 100 },
        { field: 'shiftDescription', headerName: 'Descripción Turno', width: 200 },
        { field: 'abbreviation', headerName: 'Abreviado', width: 100 },
        { field: 'changeType', headerName: 'Tipo de Cambio', width: 150 },
        { field: 'state', headerName: 'Estado', width: 150 },
        { field: 'creationUser', headerName: 'Usuario Creación', width: 120 },
        { field: 'creationDate', headerName: 'Fecha Creación', width: 150 },
        { field: 'updateUser', headerName: 'Usuario Actualización', width: 120 },
        { field: 'updated', headerName: 'Fecha Actualización', width: 150 }
    ];
};
